/** Format GAD/DOM/PDD for jobs list and edit sidebar. */
export function formatJobDateLabel(iso: string | null | undefined, withTime: boolean): string {
  if (!iso) return '';
  if (!withTime && /^\d{4}-\d{2}-\d{2}$/.test(iso)) {
    const [y, m, d] = iso.split('-').map(Number);
    return new Date(y, m - 1, d).toLocaleDateString(undefined, { dateStyle: 'medium' });
  }
  const t = new Date(iso);
  return withTime
    ? t.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })
    : t.toLocaleDateString(undefined, { dateStyle: 'medium' });
}

export function formatJobDateCell(iso: string | null | undefined, withTime: boolean): string {
  return formatJobDateLabel(iso, withTime) || '—';
}
